import { concatMap, map, of, switchMap, withLatestFrom } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SigIdCommonService } from '../../services/sig-id.common.service';
import { Injectable } from '@angular/core';
import {
  loadCalculation,
  loadCalculationFailure,
  loadCalculationSuccess,
  loadPayerServices,
  loadPayerServicesFailure,
  loadPayerServicesSuccess,
  loadPayment,
  loadPaymentFailure,
  loadPaymentSuccess
} from '../actions/my-bills.actions';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectServices } from '../selectors/my-bills.selectors';

@Injectable()
export class MyBillsEffects {
  constructor(
    private actions$: Actions,
    private store$: Store,
    private sigIdCommonService: SigIdCommonService
  ) {
  }

  loadPayerServices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPayerServices),
      withLatestFrom(this.store$.select(selectServices)),
      concatMap(([action, services]) =>
        ((services.length && !action?.force ) ? of(services) : this.sigIdCommonService.getPayerServiceList())
          .pipe(
            map((services) => loadPayerServicesSuccess({ services })),
            catchError(() => of(loadPayerServicesFailure()))
          )
      )
    )
  );

  loadPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPayment),
      switchMap(action =>
        this.sigIdCommonService.getPayment(action.identSigId, action.serviceCode, action?.idZap)
          .pipe(
            map(payment => loadPaymentSuccess({ payment })),
            catchError(() => of(loadPaymentFailure()))
          )
      )
    )
  );

  loadCalculation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCalculation),
      switchMap(action =>
        this.sigIdCommonService.getCalculation(action.identSigId, action.serviceCode)
          .pipe(
            map(calculation => loadCalculationSuccess({ calculation })),
            catchError(() => of(loadCalculationFailure()))
          )
      )
    )
  );
}
